export const filterButtons = (activeButton) => [
  {
    disabled: activeButton === 'withoutcarcass',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'withoutcarcass',
    text: 'Бескаркасные',
    id: 70,
  },

  {
    disabled: activeButton === 'hybrid',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'hybrid',
    text: 'Гибридные',
    id: 71,
  },
  {
    disabled: activeButton === 'carcass',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'carcass',
    text: 'Каркасные',
    id: 20,
  },
];
